// extracted by mini-css-extract-plugin
var _1 = "EditFacesMagneticWall-module__animateUploadProgressBarWidth--dArKv";
var _2 = "EditFacesMagneticWall-module__animatedBackground--nIioo";
var _3 = "EditFacesMagneticWall-module__avatarButton--IKIjW";
var _4 = "EditFacesMagneticWall-module__avatarButtonContainer--_B9fP";
var _5 = "20px";
var _6 = "EditFacesMagneticWall-module__container--n9fRX";
var _7 = "EditFacesMagneticWall-module__editFaceContainer--aCt1p";
var _8 = "EditFacesMagneticWall-module__hasHoveredBlot--gdN7R";
var _9 = "EditFacesMagneticWall-module__hasRing--o3Hcs";
var _a = "EditFacesMagneticWall-module__isDiffMode--kkfKA";
var _b = "EditFacesMagneticWall-module__isInBackground--qM2zE";
var _c = "EditFacesMagneticWall-module__muted--Q6HtM";
var _d = "6px";
var _e = "4px";
var _f = "EditFacesMagneticWall-module__tooltipContainer--rItz4";
var _10 = "EditFacesMagneticWall-module__tooltipName--bYcHp";
var _11 = "EditFacesMagneticWall-module__tooltipTitle--BjrLV";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarButton", _4 as "avatarButtonContainer", _5 as "avatarSize", _6 as "container", _7 as "editFaceContainer", _8 as "hasHoveredBlot", _9 as "hasRing", _a as "isDiffMode", _b as "isInBackground", _c as "muted", _d as "spacing", _e as "spacingDiffMode", _f as "tooltipContainer", _10 as "tooltipName", _11 as "tooltipTitle" }
